module.exports = __webpack_public_path__ + "media/images/front/sp/for-doctors-refine/icon_down-0af2278a91c4640e2b5e908fb7d78e2d.png";